<template>
  <div class="fonts">
    <div class="blocked-showcase">
      <h2 class="overlay-title">Acesso Bloqueado</h2>
      <p class="overlay-description">
        Para ter acesso ao sistema de gravação atualizado entre em contato através do whatsapp 49985019666, ou clique no botão abaixo para chamar direto no whatsapp.
      </p>
      <div class="overlay-buttons">
        <a href="https://wa.me/5549985019666?text=Ol%C3%A1%2C%20tenho%20interesse%20no%20novo%20sistema%20para%20grava%C3%A7%C3%A3o%20de%20chassi" target="_blank" class="btn btn-success btn-whatsapp">
          <i class="fab fa-whatsapp mr-2"></i>Fale Conosco
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Fonts'
}
</script>

<style lang="scss" scoped>
.fonts {
  padding: 40px 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>
